<template lang="pug">
  b-modal#memberReward(
    ref="memberReward"
    :title='$t("ui.combine.member_reward")'
    centered
    no-fade
    no-close-on-backdrop
    ok-only
    :busy="loading"
    @show="reset"
    @shown="shown")
    template(v-if="member")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-3
        DebounceInput(
          size="sm"
          type="text"
          v-model="memberID"
        )
      table.tablex(width="100%")
        thead
          tr
            th(colspan="2")
              span(:title="$t('ui.reward')") {{ $t("ui.reward") }}
        tbody
          tr
            td
              span(:title="$t('ui.in_game')") {{ $t('ui.in_game') }}
            td.text-center
              span(v-if="inGameReward")
                i(:class="{'fas fa-check text-info': inGameReward > 0, 'fas fa-times text-warning': inGameReward <= 0  }")
          tr
            td
              span(:title="$t('ui.inbox')") {{ $t('ui.inbox') }}
            td.text-center
              span(v-if="inboxReward")
                i(:class="{'fas fa-check text-info': inboxReward > 0, 'fas fa-times text-warning': inboxReward <= 0  }")
      div(slot="modal-ok")
        SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.close')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    member:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      inGameReward: null,
      inboxReward: null,
      memberID: null,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  mounted: function() {

  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.memberID = this.member.account_id;
      this.getMemberReward();
    },
    getMemberReward: function() {
      let url = config.monthlySummaryMemberUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.member.account_id,
        working_month: this.$moment(new Date).format("YYYY-MM-DD")
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.dt.length > 0) {
                  this.validTurnover = response.data.dt[0].valid_turnover;
                  this.winlose = response.data.dt[0].winlose;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$refs.memberReward.hide();
    },
  }
};
</script>
